import { WellOfWisdom } from "./WellOfWisdom";
import { Header } from "../../components/Header";

export const WellOfWisdomPage = () => {


    return (
        <div className="page">
            <Header />
            <WellOfWisdom />
        </div>
    );
}